enum RoutesEnum {
  // APP
  INDEX_ROUTE = '/',
  ADMIN_ROUTE = '/admin',
  // User Authententication
  LOGIN_ROUTE = '/login',
  DASHBOARD_ROUTE = '/dashboard',
  ADMIN_DASHBOARD_ROUTE = '/admin/dashboard',
  LAST_MILE_TRACK_ROUTE = '/last-mile-track',
  ADMIN_LAST_MILE_TRACK_ROUTE = '/admin/last-mile-track',
  ADMIN_MONITORING_VEHICLES_ROUTE = '/admin/monitoring-vehicles',
  REPORT_DISPATCHED_VEHICLES_ROUTE = '/report-dispatched-vehicles',
  ADMIN_REPORT_DISPATCHED_VEHICLES_ROUTE = '/admin/report-dispatched-vehicles',
  USERS_ROUTE = '/users',
  REGISTER_ROUTE = '/register',
  RECOVER_PASSWORD_ROUTE = '/recover-password',
  NEW_PASSWORD_ROUTE = '/reset-password/:token',
  REQUEST_PAGE_ROUTE = '/requests',
  VIEW_PROFILE_ROUTE = '/profile',
  FAQ_ROUTE = '/faq',
  FAQ_SECTION_ROUTE = '/faq/:slug',
  REQUEST_PAGE_ADMIN_ROUTE = '/admin/requests',
  STOCK_PAGE_ROUTE = '/stocks',
  API_INTEGRATION_PAGE_ROUTE = '/api-integration',
  STOCK_PAGE_ADMIN_ROUTE = '/admin/stocks',
  OPERATIONAL_METRICS_PAGE_ADMIN_ROUTE = '/admin/operational-metrics',
  OPERATIONAL_METRICS_PAGE_ROUTE = '/operational-metrics',
  DISAPPROVE_VEHICLES_PAGE_ADMIN_ROUTE = '/admin/requests/disapprove',
  MANAGE_REVIEWS_ADMIN_ROUTE = '/admin/platform-rating',
  VIEW_CLIENT_ROUTE = '/admin/clients',
  EDIT_CLIENT_ROUTE = '/admin/clients/edit-client/:id',
  EDIT_CLIENT_ROUTE_REDIRECT = '/admin/clients/edit-client',
  ADD_USER_ROUTE = '/admin/user/add-user',
  EDIT_USER_ROUTE = '/admin/user/edit-user/:id',
  EDIT_USER_ROUTE_REDIRECT = '/admin/user/edit-user',
  // Routes Team
  VIEW_TEAM_ROUTE = '/admin/team',
  SERVICE_ROUTE = '/admin/service',
  SERVICE_EDIT_ROUTE = '/admin/service/:service',
  SERVICE_CLIENT_ROUTE = '/services',
  // Routes Request Preparation
  ADMIN_REQUEST_PREPARATION_CREATE_ROUTE = '/admin/request-preparation/create',
  ADMIN_REQUEST_PREPARATION_LIST_ROUTE = '/admin/request-preparation/list',
  REQUEST_PREPARATION_CREATE_ROUTE = '/request-preparation/create',
  REQUEST_PREPARATION_LIST_ROUTE = '/request-preparation/list',
  VIEW_DETAILS_REQUEST_PREPARATION_ROUTE = '/details-request-preparation/:id',

  VIEW_VEHICLE_ROUTE = '/vehicle/:id',
  VIEW_VEHICLE_ROUTE_REDIRECT = '/vehicle',
  
  VIEW_GROUP_ROUTE = '/admin/group',
  VIEW_GROUP_USERS_ROUTE = '/admin/group/users/:id',
  VIEW_GROUP_USERS_REDIRECT = '/admin/group/users',
  ADD_GROUP_ROUTE = '/admin/group/add-group',
  EDIT_GROUP_ROUTE = '/admin/group/edit-group/:id',
  EDIT_GROUP_ROUTE_REDIRECT = '/admin/group/edit-group',

  ADMIN_VIEW_SEARCH_VEHICLES_ROUTE = '/admin/search-vehicles',
  VIEW_SEARCH_VEHICLES_ROUTE = '/search-vehicles',
}

export default RoutesEnum;
